module.exports = __webpack_public_path__ + "img/what-is-GB-WhatsApp.71d66b5f.webp";